module.exports = __webpack_public_path__ + "static/media/convertir_artista_linea_4.80eb12f8.svg";